import { z, type infer as zInfer } from "zod";
import { timestamp } from "hooks/firestore/v2/models/timestamp";
import { promotionCampaign } from "hooks/firestore/v2/models/promotionCampaign";

const exotictMarketTypes = z.enum([
  "QUINELLA",
  "EXACTA",
  "TRIFECTA",
  "FIRST_4",
]);

export const racingEventStatusEnum = z.enum([
  "OPEN",
  "CLOSED",
  "CANCELLED",
  "INTERIM",
  "PROTEST",
  "FINAL",
  "DONE",
  "JUMPED",
  "ABANDONED",
]);

export const racingEvent = z.object({
  distance: z.string(),
  meetingDate: z.string(),
  meetingId: z.string(),
  meetingTrackType: z.string().optional(),
  name: z.string(),
  number: z.number(),
  scheduledStartTime: z.string(),
  scheduledStartTimeTs: timestamp,
  status: racingEventStatusEnum,
  venue: z.string(),
  silksUrl: z.string(),
  results: z.record(z.string(), z.string()),
  comment: z.string().nullish(),
  sport: z.enum(["HORSE_RACING", "GREYHOUNDS", "HARNESS_RACING"]),
  region: z.enum(["ANZ", "ROW"]),
  promotionIsAvailable: z.boolean().optional(),
  venueCountry: z.string(),
  venueState: z.string().optional(),
  trackType: z.string().nullish(),
  semAvailableAtTs: timestamp.nullish(),
  filters: z.array(z.string()).nullish(),
  exoticResults: z.record(
    exotictMarketTypes,
    z
      .record(
        z.string(),
        z.object({
          dividend: z.number(),
          outcomeIds: z.array(z.string()),
          runners: z.array(z.number()),
        }),
      )
      .optional(),
  ),
  visible: z.boolean().nullish(),
  promotionCampaigns: z.array(promotionCampaign).nullish(),
  hasPromotionalMarkets: z.boolean().optional(),
  showPromoBanner: z.boolean().optional(),
  expectedResults: z.record(z.string(), z.number()),
  closeTime: z.string().optional(),
  eventClass: z.string().optional(),
  surface: z.string().optional(),
});

export type RacingEvent = zInfer<typeof racingEvent>;
export type ExoticMarketTypes = zInfer<typeof exotictMarketTypes>;
export type RacingEventStatus = zInfer<typeof racingEventStatusEnum>;
